import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
  if (placement === 'center' || arrowPosition === 'center') {
    return {
      top: arrowY
    };
  }
  if (placement === 'end') {
    return {
      bottom: arrowOffset
    };
  }
  if (placement === 'start') {
    return {
      top: arrowOffset
    };
  }
  return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
  if (placement === 'center' || arrowPosition === 'center') {
    return {
      left: arrowX
    };
  }
  if (placement === 'end') {
    return _defineProperty({}, dir === 'ltr' ? 'right' : 'left', arrowOffset);
  }
  if (placement === 'start') {
    return _defineProperty({}, dir === 'ltr' ? 'left' : 'right', arrowOffset);
  }
  return {};
}
function getArrowPositionStyles(_ref3) {
  var position = _ref3.position,
    arrowSize = _ref3.arrowSize,
    arrowOffset = _ref3.arrowOffset,
    arrowPosition = _ref3.arrowPosition,
    arrowX = _ref3.arrowX,
    arrowY = _ref3.arrowY,
    dir = _ref3.dir;
  var _position$split = position.split('-'),
    _position$split2 = _slicedToArray(_position$split, 2),
    side = _position$split2[0],
    _position$split2$ = _position$split2[1],
    placement = _position$split2$ === void 0 ? 'center' : _position$split2$;
  var baseStyles = {
    width: arrowSize,
    height: arrowSize,
    borderRadius: '17% 0',
    position: 'absolute'
  };
  var arrowPlacement = -arrowSize / 2;
  if (side === 'left') {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyles), horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {}, {
      right: arrowPlacement,
      transform: 'rotate(-37deg) skewX(16deg) scale(1, 0.961)',
      borderLeftColor: 'transparent',
      borderBottomColor: 'transparent'
    });
  }
  if (side === 'right') {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyles), horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {}, {
      left: arrowPlacement,
      transform: 'rotate(143deg) skewX(16deg) scale(1, 0.961)',
      borderRightColor: 'transparent',
      borderTopColor: 'transparent'
    });
  }
  if (side === 'top') {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyles), verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {}, {
      bottom: arrowPlacement,
      transform: 'rotate(-127deg) skewX(16deg) scale(1, 0.961)',
      borderTopColor: 'transparent',
      borderLeftColor: 'transparent'
    });
  }
  if (side === 'bottom') {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyles), verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {}, {
      top: arrowPlacement,
      transform: 'rotate(53deg) skewX(16deg) scale(1, 0.961)',
      borderBottomColor: 'transparent',
      borderRightColor: 'transparent'
    });
  }
  return {};
}

export { getArrowPositionStyles };
//# sourceMappingURL=get-arrow-position-styles.js.map
